import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../_common/button';

export default function ScrollToTopBtn({ onClick, showBtn }) {
  const btnClass = `btn btn-outline-secondary scroll-to-top-btn ${
    showBtn ? '' : 'd-none'
  }`;

  return (
    <Button type="button" className={btnClass} onClick={onClick}>
      <span className="scroll-to-top-btn__icon"></span>
      <span className="scroll-to-top-btn__text">Return To Top</span>
    </Button>
  );
}

ScrollToTopBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
  showBtn: PropTypes.bool.isRequired,
};
